import { render, staticRenderFns } from "./WalletsManagement.vue?vue&type=template&id=38b513c0&scoped=true&"
import script from "./WalletsManagement.vue?vue&type=script&lang=js&"
export * from "./WalletsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b513c0",
  null
  
)

export default component.exports